import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { ToastrService } from 'ngx-toastr';
import { Agent, AgentInfoWithProfilePic, ViolationData } from 'src/app/interfaces/agent.interface';
import { ActionData, IProfanityDetails, IScreenGlanceDetails, Violation, ViolationDetails } from 'src/app/interfaces/Violation.interface';
import { AgentListInfo } from 'src/app/services/agent.list.info';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { LogUpload } from 'src/app/utils/log-upload';
import { log } from 'src/app/utils/logging';
import { FormatViolationDateTime, getFormattedDateTime, getUTCDateObj } from 'src/app/utils/timeManager';
import { AuditService } from '../../../../services/audit.service';
import { playNotificationSound } from 'src/app/utils/sound';
import { Router } from '@angular/router';
import { requestNotificationPermission, showNotification } from 'src/app/utils/notifications';
import { IViolationNotificationType } from 'src/app/interfaces/app-config.interface';
import { TranslocoService } from '@ngneat/transloco';
import { ISecureAssistEvent, ISecureAssistProfanityAudioEvent } from 'src/app/interfaces/secure-assist';
import { TeamCheckInService } from 'src/app/services/team.checkin.service';
import { EventFilterService } from 'src/app/services/event-filter.service';

@Component({
  selector: 'app-active-agents',
  queries: {
    "scrollContainerRef": new ViewChild("scrollContainerRef")
  },
  templateUrl: './active-agents.component.html',
  styleUrls: ['./active-agents.component.sass'],

})

export class ActiveAgentsComponent implements OnInit, AfterViewInit {
  private tempAgentInfo: { [key: string]: Agent } = {}; // to store details of agent received during supervisor init
  paginationAgents: Agent[] = [];
  supervisorConnectivityCssClass = "bg-warning";
  appConfig = AppConfig;
  selectedLanId: string; //LanID of selected Agent
  selectedProfilePic: string; //LanID of selected Agent
  showViolationHistoryWidget: boolean = false;
  showChatWidget: boolean = false;
  additionalButtons: boolean = false;
  enabledViolations: string[] = [];
  sortOrder = 'ASC';
  searchText: string;
  selectedTime = {};
  dontSelect = false;
  AgentTime: any;
  userMode = 'supervisor';
  archivedView: boolean = false;
  supervisorCanViewMedia: boolean = true;
  agentsCount = 0;
  hideLoading: boolean = false;
  connectionTime: any;
  hideTeamsFilter: boolean = true;
  hideStatusFilter: boolean = true;
  isScreenblockFilterEnabled: boolean = false;
  teamsFilter: string[] = [];
  statusFilter: string[] = [];
  archivedAgentsCount = 0;
  archivedTeamCount = 0;
  pendingStealthRequested: any = {};
  hideConfimationPopUp: boolean = true;
  dashboardView: boolean = false;
  gamificationView: any;
  selectedAgentViolations: any[];
  isEventsGlobalFilterHidden: boolean = true;
  eventFilter: Set<string> = new Set();
  isGlobalFilterHidden: boolean = true;

  AgentStatus: string;
  hideWaitingPopUp = true;

  scrollContainerRef!: ElementRef; // Using "definite assignment" assertion (query).

  public config: PaginationInstance = {
    id: 'paginationid',
    itemsPerPage: 20,
    currentPage: 1
  };

  totalPages = 1;

  logUploader: LogUpload = new LogUpload("ActiveAgentsComponent");

  violationsPerPage: number = this.appConfig.settings.defaults.ViolationsLoadedPerRequest;

  loadingAgentDetailsLabel: string = "";
  goBackLabel: string = "";
  archivedAgentsLabel: string = "";
  activeAgentsLabel: string = "";
  agentCountLabel: string = "";
  refreshLabel: string = "";
  archivedLabel: string = "";
  activeLabel: string = "";
  noAgentsArchivedLabel: string = "";
  noRecordsMatchedLabel: string = "";
  itemsPerPageLabel: string = "";
  previousLabel: string = "";
  nextLabel: string = "";
  pendingStealthRequestsLabel: string = "";
  concludeStealthRequestsLabel: string = "";
  okLabel: string = "";
  pleaseWaitLabel: string = "";
  updatingLabel: string = "";
  searchLabel: string = "";
  logUploadedSuccessfullyLabel: string = "";
  stealthModeRequestedLabel: string = "";
  teamCheckInLabel: string = "";

  constructor(public trsService: TrsEventsService, private toastrService: ToastrService, public agentListInfoService: AgentListInfo,
    private auditService: AuditService, private router: Router, private translationService: TranslocoService, public teamCheckInService: TeamCheckInService,
    private eventFilterService: EventFilterService) {
    this.updateComponentLabels();
  }

  ngAfterViewInit(): void {
    this.initializeTooltip();
  }

  ngOnInit(): void {
    if (this.trsService.supervisorId != null && this.trsService.supervisorId !== "") {
      this.logUploader.info("ngOnInit", "Active Agent Component");
      this.selectedLanId = "";

      Object.entries(this.appConfig.settings.ViolationNotificationTypes).forEach(([key, value]) => {
        if (value.enabled)
          this.enabledViolations.push(key);
      });

      requestNotificationPermission();

      this.trsService.evtDataObservable.subscribe(response => {
        switch (response.eventName) {
          case "UPDATE_APP_LABELS": this.updateComponentLabels(); break;
          case "GETAGENTSESSIONLIST": this.getAgentsList(response); break;
          case "SUPERVISORINIT": this.getSupervisorInit(response); break;
          case "FILTER_AGENTS_BY_TEAM": this.filterAgentsByTeam(response.data); break;
          case "FILTER_AGENTS_BY_STATUS": this.filterAgentsByStatus(response.data); break;
          case "CLIENTLOGUPLOADED": this.uploadLogStatus(response.data); break;
          case "TRSLOGGEDIN": this.trsClientLoggedIn(response); break;
          case "TRSCLIENTCONNECTED": this.trsClientConnected(response); break;
          case "TRSCLIENTDISCONNECTED": this.trsClientDisconnected(response); break;
          case "CHATMESSAGERECEIVED": this.handleChatMessageReceived(response); break;
          case "CHATMESSAGE": this.handleChatMessage(response); break;
          case "PEEP": this.handlePeep(response); break;
          case "PEEPCOMPLETE": this.handlePeepComplete(response); break;
          case "PEEPDENIED": this.handlePeepDenied(response); break;
          case "VIOLATION": this.handleViolation(response.data.AgentLanId, response.data.ViolationDetails, true, true); break;
          case "STEALTHMODE":
            //Event when Stealth is requested or activated or deactivated
            this.handleStealthMode(response); break;
          case "CUSTOM_STEALTHMODE_ACTION":
            //Event when Stealth is activated or deactivated by logged in Supervisor
            this.handleActivateStealthMode(response); break;
          case "SCREENBLOCKAPPROVED":
          case "BLOCKAPPROVED": this.handleScreenBlockApproved(response); break;
          case "UNBLOCKAPPROVED": this.handleUnBlockScreenApproved(response); break;
          case "PINAGENT": this.handlePinAgentResponse(response); break;
          case "ARCHIVEAGENT": this.handleArchivedAgentResponse(response); break;
          case "CUSTOM_PIN_AGENT":
          case "CUSTOM_ARCHIVE_AGENT":
            this.handlePinAndArchiveUI();
            this.dontSelectAgents(response);
            break;
          case "CUSTOM_SETTINGS_SELECTED": this.dontSelectAgents(response); break;
          case "SUPERADMIN_MODE": this.handleSuperAdminMode(response.data); break;
          case "LOADNEXTVIOLATIONS": this.handleLoadExtViolations(response.data); break
          case "VIOLATIONWORKFLOW": this.handleViolationWorkflow(response.data); break;
          case "GO_BACK": this.goBackToAllAgents(); break;
          case "LOGOUT-SSO": this.SSOLogOut(); break;
          case "LOGOUT-IAM": this.IAMLogout(); break;
          case "LOGOUT": this.handleLogOut(true, "", false); break;
          case "AUXCODECHANGE": this.handleAuxCodeChange(response.data.AgentLanId, response.data.AgentCurrentAuxCode); break;
          case "DISAGREEVIOLATION": this.handleDisagreeViolation(response.data); break;
          case "DASHBOARD_MODE": this.handleDashboardMode(response.data); break;
          case "GAMIFICATION_MODE": this.handleGamificationMode(response.data); break;
          case "SCREENGRABDATA": this.handleScreenGrabApproved(response); break;
          case "SCREENGRABDENIED": this.handleScreenGrabDenied(response); break;
          // case "BARGEINDECLINED": this.handleBargeInDenied(response); break;
          case "OFFERDECLINED": this.handlOfferDenied(response); break;
          case "NETWORK_RECONNECT": this.onNetworkReconnected(); break;
          case "PROFANITYWORDSDETECTED":
          case "NEGATIVESENTIMENTDETECTED": this.handleSecureAssistEvent(response.data); break;
          case "PROFANITYAUDIO": this.handleSecureAssistProfanityAudioEvent(response.data); break;
          case "ADD_VIOLATION": this.handleViolation(response.data.AgentLanId, response.data.ViolationDetails, false, false); break;
          case "FILTER_AGENTS_BY_EVENTS": this.filterAgentsByEvents(response.data); break;
          case "FILTER_AGENTS_BY_SCREENBLOCK": this.toggleScreenblockFilter(); break;
          case "CLEAR_ALL_FILTERS": this.clearAllFilters(); break;

          case "BARGEIN":
          case "BARGEININIT":
          case "BARGEININPROGRESS":
          case "ENDBARGEIN":
          case "BARGEINLIMITREACHED":
          case "BARGEININITDECLINED": this.addRealtimeScreenGlanceEventToHistory(response.eventName, response.data); break;
        }
      });
    }
    else this.router.navigate([""]);
  }

  pageChanged(page: number): void {
    this.config.currentPage = page;
    this.paginationAgents = [];

    const begin: number = (this.config.currentPage - 1) * this.config.itemsPerPage;
    const end: number = begin + this.config.itemsPerPage;
    const initialOrderList: string[] = this.agentListInfoService.GetOrderList();

    if (this.archivedView === true) {
      if (this.isFilterEnabled() === true) {
        let modifiedOrderList: string[] = [];

        initialOrderList.forEach((lanid: string) => {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanid);
          if (agentInfo != null) {
            if (agentInfo.IsArchived === true) {
              if (this.isScreenblockFilterEnabled === true) {
                if (agentInfo.IsScreenBlocked === true)
                  modifiedOrderList.push(agentInfo.LanID);
              }
              else if (this.teamsFilter != null && this.teamsFilter.length > 0) {
                if (this.teamsFilter.includes(agentInfo.AgentTeamName.toLowerCase()) === true)
                  modifiedOrderList.push(agentInfo.LanID);
              }
              else if (this.statusFilter != null && this.statusFilter.length > 0) {
                if (this.statusFilter.includes(agentInfo.LoginStatus.toLowerCase()) === true)
                  modifiedOrderList.push(agentInfo.LanID);
              }
              else if (this.eventFilter != null && this.eventFilter.size > 0) {
                for (let eventName of this.eventFilter) {
                  if (agentInfo.EventNames.has(eventName)) {
                    modifiedOrderList.push(agentInfo.LanID);
                    break;
                  }
                }
              }
              else if (this.searchText != null && this.searchText.length > 0) {
                if (agentInfo.FullName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                  agentInfo.AgentTeamName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                  agentInfo.LoginStatus.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                  modifiedOrderList.push(agentInfo.LanID);
                }
              }
            }
          }
        });

        this.totalPages = Math.ceil(modifiedOrderList.length / this.config.itemsPerPage);
        this.config.totalItems = modifiedOrderList.length;

        modifiedOrderList = modifiedOrderList.slice(begin, end);

        modifiedOrderList.forEach((lanid: string) => {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanid);
          if (agentInfo != null) {
            if (agentInfo.IsArchived === true) {
              if (this.isScreenblockFilterEnabled === true) {
                if (agentInfo.IsScreenBlocked === true)
                  this.paginationAgents.push(agentInfo);
              }
              else if (this.teamsFilter != null && this.teamsFilter.length > 0) {
                if (this.teamsFilter.includes(agentInfo.AgentTeamName.toLowerCase()) === true)
                  this.paginationAgents.push(agentInfo);
              }
              else if (this.statusFilter != null && this.statusFilter.length > 0) {
                if (this.statusFilter.includes(agentInfo.LoginStatus.toLowerCase()) === true)
                  this.paginationAgents.push(agentInfo);
              }
              else if (this.eventFilter != null && this.eventFilter.size > 0) {
                for (let eventName of this.eventFilter) {
                  if (agentInfo.EventNames.has(eventName)) {
                    modifiedOrderList.push(agentInfo.LanID);
                    break;
                  }
                }
              }
              else if (this.searchText != null && this.searchText.length > 0) {
                if (agentInfo.FullName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                  agentInfo.AgentTeamName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                  agentInfo.LoginStatus.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                  this.paginationAgents.push(agentInfo);
                }
              }
            }
          }
        });
      }
      else {
        let modifiedOrderList: string[] = [];

        initialOrderList.forEach((lanid: string) => {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanid);
          if (agentInfo != null) {
            if (agentInfo.IsArchived === true) {
              modifiedOrderList.push(agentInfo.LanID);
            }
          }
        });

        this.totalPages = Math.ceil(modifiedOrderList.length / this.config.itemsPerPage);
        this.config.totalItems = modifiedOrderList.length;

        modifiedOrderList = modifiedOrderList.slice(begin, end);

        modifiedOrderList.forEach((lanid: string) => {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanid);
          if (agentInfo != null) {
            if (agentInfo.IsArchived === true) {
              this.paginationAgents.push(agentInfo);
            }
          }
        });
      }
    }
    else {
      if (this.isFilterEnabled() === true) {
        let modifiedOrderList: string[] = [];

        initialOrderList.forEach((lanid: string) => {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanid);
          if (agentInfo != null) {
            if (agentInfo.IsArchived === false) {
              if (this.isScreenblockFilterEnabled === true) {
                if (agentInfo.IsScreenBlocked === true) {
                  modifiedOrderList.push(agentInfo.LanID);
                }
              }
              else if (this.teamsFilter != null && this.teamsFilter.length > 0) {
                if (this.teamsFilter.includes(agentInfo.AgentTeamName.toLowerCase()) === true) {
                  modifiedOrderList.push(agentInfo.LanID);
                }
              }
              else if (this.statusFilter != null && this.statusFilter.length > 0) {
                if (this.statusFilter.includes(agentInfo.LoginStatus.toLowerCase()) === true) {
                  modifiedOrderList.push(agentInfo.LanID);
                }
              }
              else if (this.eventFilter != null && this.eventFilter.size > 0) {
                for (let eventName of this.eventFilter) {
                  if (agentInfo.EventNames.has(eventName)) {
                    modifiedOrderList.push(agentInfo.LanID);
                    break;
                  }
                }
              }
              else if (this.searchText != null && this.searchText.length > 0) {
                if (agentInfo.FullName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                  agentInfo.AgentTeamName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                  agentInfo.LoginStatus.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                  modifiedOrderList.push(agentInfo.LanID);
                }
              }
            }
          }
        });

        this.totalPages = Math.ceil(modifiedOrderList.length / this.config.itemsPerPage);
        this.config.totalItems = modifiedOrderList.length;

        modifiedOrderList = modifiedOrderList.slice(begin, end);

        modifiedOrderList.forEach((lanid: string) => {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanid);
          if (agentInfo != null) {
            if (agentInfo.IsArchived === false) {
              if (this.isScreenblockFilterEnabled === true) {
                if (agentInfo.IsScreenBlocked === true) {
                  this.paginationAgents.push(agentInfo);
                }
              }
              else if (this.teamsFilter != null && this.teamsFilter.length > 0) {
                if (this.teamsFilter.includes(agentInfo.AgentTeamName.toLowerCase()) === true) {
                  this.paginationAgents.push(agentInfo);
                }
              }
              else if (this.statusFilter != null && this.statusFilter.length > 0) {
                if (this.statusFilter.includes(agentInfo.LoginStatus.toLowerCase()) === true) {
                  this.paginationAgents.push(agentInfo);
                }
              }
              else if (this.eventFilter != null && this.eventFilter.size > 0) {
                for (let eventName of this.eventFilter) {
                  if (agentInfo.EventNames.has(eventName)) {
                    this.paginationAgents.push(agentInfo);
                    break;
                  }
                }
              }
              else if (this.searchText != null && this.searchText.length > 0) {
                if (agentInfo.FullName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                  agentInfo.AgentTeamName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                  agentInfo.LoginStatus.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                  this.paginationAgents.push(agentInfo);
                }
              }
            }
          }
        });
      }
      else {
        let modifiedOrderList: string[] = [];

        initialOrderList.forEach((lanid: string) => {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanid);
          if (agentInfo != null) {
            if (agentInfo.IsArchived === false) {
              modifiedOrderList.push(agentInfo.LanID);
            }
          }
        });

        this.totalPages = Math.ceil(modifiedOrderList.length / this.config.itemsPerPage);
        this.config.totalItems = modifiedOrderList.length;

        modifiedOrderList = modifiedOrderList.slice(begin, end);

        modifiedOrderList.forEach((lanid: string) => {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanid);
          if (agentInfo != null) {
            if (agentInfo.IsArchived === false) {
              this.paginationAgents.push(agentInfo);
            }
          }
        });
      }
    }

    this.scrollContainerRef.nativeElement.scrollTo(0, 0);
  }

  pageSizeChange(pSize: any): void {
    this.config.itemsPerPage = parseInt(pSize)
    this.pageChanged(1)
  }

  handleScreenGrabApproved(response: any) {
    this.enableChatNotificationIcon(response);

    this.agentListInfoService.UpdateScreenGrabRequestStatus(response.data.From, false);

    let data: any = {};
    data.ViolationName = "Screen Grab Response";
    data.ActionName = "Screen Grab Response";
    data.AgentLanId = response.data.From;
    data.Show = false;
    data.ShowInChat = true;
    data.ViolationId = response.data.ViolationId;
    data.EventId = response.data.EventId;

    if (this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal === true)
      data.ViolationDateTime = new Date().toISOString();
    else data.ViolationDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal);

    if (response.data.body.indexOf("http://") > -1 || response.data.body.indexOf("https://") > -1) {
      data.ImageURI = response.data.body;
    }
    else {
      data.ImageURI = `data:image/jpg;base64,${response.data.body}`;
    }

    this.addChatEventToViolationList(response.data.From, response.data.EventId, data.ViolationName, data);
    this.playNotification(response.data.From, data.ViolationName);
    this.MoveAgentLanIdToTop(response.data.From);
  }

  handlOfferDenied(response: any) {
    response.data.AgentLanId = response.data.To;
    this.enableChatNotificationIcon(response);

    let data: any = {};
    data.ViolationName = "Call Declined";
    data.ActionName = "Call Declined";
    data.To = response.data.From;
    data.ViolationDateTime = new Date();
    data.Show = false;
    data.ShowInChat = true;

    this.addChatEventToViolationList(response.data.To, response.data.EventId, response.data.ViolationName, data);

    if (this.agentListInfoService.IsArchived(response.data.AgentLanId) === false) {
      if (this.appConfig.settings.ExcludedViolationsForNotificationSounds.includes(data.ViolationName) === false) {
        playNotificationSound();
      }
    }
  }

  handleBargeInDenied(response: any) {
    this.enableChatNotificationIcon(response);

    let data: any = {};
    data.ViolationName = "BargeIn Denied";
    data.ActionName = "BargeIn Denied";
    data.To = response.data.From;
    data.ViolationDateTime = new Date();
    data.Show = false;
    data.ShowInChat = true;

    this.addChatEventToViolationList(response.data.To, response.data.EventId, data.ViolationName, data);
  }

  handleScreenGrabDenied(response: any) {
    this.enableChatNotificationIcon(response);

    this.agentListInfoService.UpdateScreenGrabRequestStatus(response.data.From, false);

    let data: any = {};
    data.ViolationName = "Screen Grab Denied";
    data.ActionName = "Screen Grab Denied";
    data.AgentLanId = response.data.From;
    data.Show = false;
    data.ShowInChat = true;

    if (this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal === true)
      data.ViolationDateTime = new Date().toISOString();
    else data.ViolationDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal);

    this.addChatEventToViolationList(response.data.From, response.data.EventId, response.data.ViolationName, data);
    this.playNotification(response.data.AgentLanId, data.ViolationName);
    this.MoveAgentLanIdToTop(response.data.AgentLanId);
  }

  handleDashboardMode(data: any) {
    this.dashboardView = data.dashboardView;
    this.gamificationView = false;
    this.userMode = 'superadmin';
  }

  handleGamificationMode(data: any) {
    this.gamificationView = true;
    this.dashboardView = false;
    this.userMode = 'superadmin';
  }

  handleLogOut = (reloadPage: boolean, navigationURL: string | null, redirectToInternalLogoutPage: boolean) => {
    if (Object.keys(this.pendingStealthRequested).length > 0) {
      this.conditionalStealthModeClicked();
    }
    else this.sendEvent("LOGOUT_SUPERVISOR", { reloadPage, navigationURL, redirectToInternalLogoutPage });
  }

  handleDisagreeViolation = (data: any): void => {
    if (this.trsService.events != null && this.trsService.events[data.AgentId] != null) {
      const Violationindex: number = this.trsService.events[data.AgentId].findIndex((violation: { ViolationId: any; }) => violation.ViolationId == data.ViolationId);
      if (Violationindex >= 0) {
        this.trsService.events[data.AgentId][Violationindex].ReviewStatus = data.ReviewStatus;
        this.trsService.events[data.AgentId][Violationindex].RejectionComment = data.RejectionComment;
      }
      else log.error(`Unable to handle disagree event as violation id ${data.ViolationId} for agent${data.AgentId} is not present in internal list`);
    }
    else log.error(`Unable to handle disagree event as agent ${data.AgentId} is not present in internal list`);
  }

  handleAuxCodeChange(lanId: string, auxCode: "LoggedIn" | "Busy" | "Meeting" | "0" | "Available" | "Logged Out" | "Break") {
    this.agentListInfoService.UpdateCurrentAuxCode(lanId, auxCode);

    log.info(`Aux code for user with lanid ${lanId} changed to ${auxCode}`);

    switch (auxCode) {
      case "LoggedIn":
        this.agentListInfoService.UpdateLoginStatusMessage(lanId, "Logged In");
        break;
      case "0":
        this.agentListInfoService.UpdateLoginStatusMessage(lanId, "Available");
        break;
      default:
        this.agentListInfoService.UpdateLoginStatusMessage(lanId, auxCode);
        break;
    }

    this.sendEvent("AUXCODECHANGE_INTERNAL", lanId);
  }

  filterAgentsByTeam(teamList: any[]) {
    this.resetAllFilters("teams");
    this.teamsFilter = teamList;
    this.pageChanged(1);
    this.updateCounts();
  }

  filterAgentsByStatus(statusList: any[]) {
    this.resetAllFilters("status");
    this.statusFilter = statusList;
    this.pageChanged(1);
    this.updateCounts();
  }

  toggleView() {
    this.resetAllFilters("");
    this.pageChanged(1);
    this.updateCounts();
    this.sendEvent("TOGGLE_ARCHIVE_VIEW", { IsArchivedView: this.archivedView })
  }

  toggleTeamsFilter() {
    if (this.hideLoading) {
      this.hideTeamsFilter = !this.hideTeamsFilter
    }
  }

  hideTeamFilterPopup() {
    this.hideTeamsFilter = true;
  }

  toggleStatusFilter() {
    if (this.hideLoading) {
      this.hideStatusFilter = !this.hideStatusFilter;
    }
  }

  hideStatusFilterPopup() {
    this.hideStatusFilter = true;
  }

  updateCounts(updatePage: boolean = true) {
    let agentCount: number = 0;
    let teams: { [key: string]: number } = {};

    const allAgentInfo: Agent[] = this.agentListInfoService.GetAllAgentInfo();

    if (this.archivedView === true) {
      if (this.isFilterEnabled() === true) {
        allAgentInfo.forEach((agentInfo: Agent) => {
          if (agentInfo.IsArchived === true) {
            if (this.isScreenblockFilterEnabled === true) {
              if (agentInfo.IsScreenBlocked === true) {
                agentCount++;
                teams[agentInfo.AgentTeamName] = 1;
              }
            }
            else if (this.teamsFilter != null && this.teamsFilter.length > 0) {
              if (this.teamsFilter.includes(agentInfo.AgentTeamName.toLowerCase()) === true) {
                agentCount++;
                teams[agentInfo.AgentTeamName] = 1;
              }
            }
            else if (this.statusFilter != null && this.statusFilter.length > 0) {
              if (this.statusFilter.includes(agentInfo.LoginStatus.toLowerCase()) === true) {
                agentCount++;
                teams[agentInfo.AgentTeamName] = 1;
              }
            }
            else if (this.eventFilter != null && this.eventFilter.size > 0) {
              for (let eventName of this.eventFilter) {
                if (agentInfo.EventNames.has(eventName)) {
                  agentCount++;
                  teams[agentInfo.AgentTeamName] = 1;
                }
              }
            }
            else if (this.searchText != null && this.searchText.length > 0) {
              if (agentInfo.FullName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                agentInfo.AgentTeamName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                agentInfo.LoginStatus.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                agentCount++;
                teams[agentInfo.AgentTeamName] = 1;
              }
            }
          }
        });
      }
      else allAgentInfo.forEach((agentInfo: Agent) => {
        if (agentInfo.IsArchived === true) {
          agentCount++;
          teams[agentInfo.AgentTeamName] = 1;
        }
      });
    }
    else {
      if (this.isFilterEnabled() === true) {
        allAgentInfo.forEach((agentInfo: Agent) => {
          if (agentInfo.IsArchived === false) {
            if (this.isScreenblockFilterEnabled === true) {
              if (agentInfo.IsScreenBlocked === true) {
                agentCount++;
                teams[agentInfo.AgentTeamName] = 1;
              }
            }
            else if (this.teamsFilter != null && this.teamsFilter.length > 0) {
              if (this.teamsFilter.includes(agentInfo.AgentTeamName.toLowerCase()) === true) {
                agentCount++;
                teams[agentInfo.AgentTeamName] = 1;
              }
            }
            else if (this.statusFilter != null && this.statusFilter.length > 0) {
              if (this.statusFilter.includes(agentInfo.LoginStatus.toLowerCase()) === true) {
                agentCount++;
                teams[agentInfo.AgentTeamName] = 1;
              }
            }
            else if (this.eventFilter != null && this.eventFilter.size > 0) {
              for (let eventName of this.eventFilter) {
                if (agentInfo.EventNames.has(eventName)) {
                  agentCount++;
                  teams[agentInfo.AgentTeamName] = 1;
                }
              }
            }
            else if (this.searchText != null && this.searchText.length > 0) {
              if (agentInfo.FullName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                agentInfo.AgentTeamName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 ||
                agentInfo.LoginStatus.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                agentCount++;
                teams[agentInfo.AgentTeamName] = 1;
              }
            }
          }
        });
      }
      else allAgentInfo.forEach((agentInfo: Agent) => {
        if (agentInfo.IsArchived === false) {
          agentCount++;
          teams[agentInfo.AgentTeamName] = 1;
        }
      });
    }

    this.agentsCount = agentCount;

    if (this.archivedView == true)
      this.archivedTeamCount = Object.keys(teams).length;

    if (updatePage === true)
      this.pageChanged(1);
  }

  uploadLogStatus(response: any) {
    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(response.AgentLanId);
    if (agentInfo != null) {
      if (agentInfo.UploadLogStatus === true) {
        this.agentListInfoService.UpdateUploadLogStatus(response.AgentLanId, false);
        this.toastrService.success(`${this.logUploadedSuccessfullyLabel} ${response.AgentLanId}`);
      }

      this.MoveAgentLanIdToTop(response.AgentLanId);
    }
  }

  searching(searchText: string) {
    if (searchText == null || searchText === "") {
      this.resetAllFilters("");
      this.pageChanged(1);
    }
    else {
      this.resetAllFilters("search");
      this.pageChanged(1);
    }
  }

  MoveAgentLanIdToTop = (lanid: string): void => {
    this.agentListInfoService.MoveAgentToTopOfOrderList(lanid);
    this.pageChanged(this.config.currentPage);
  }

  handleViolationWorkflow(data: any) {
    if (this.agentListInfoService.IsArchived(data.AgentId)) {
      return;
    }

    this.agentListInfoService.UpdateChatEnabled(data.AgentId, true);

    let msg = {
      ActionName: "VIOLATIONWORKFLOW",
      ViolationName: "Violation sent for Approval",
      AgentLanId: data.AgentId,
      ViolationDateTime: new Date(),  //1.
      Show: false,
      ShowInChat: true
    };
    this.enableChatNotificationIcon({ "data": msg });

    this.trsService.events[data.AgentId].push(msg);

    this.MoveAgentLanIdToTop(data.AgentId);
  }

  handleLoadExtViolations(data: ViolationData) {
    for (const [key, value] of Object.entries(data.Violations)) {
      log.debug(`Processing violation list for agent ${key}`, value);
      if (this.agentListInfoService.DoesKeyExist(key) === true) {
        if (value == null || value.length === 0) {
          const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(key);
          if (agentInfo != null) {
            if (this.agentListInfoService.AreInitialViolationsLoaded(key) === false)
              this.agentListInfoService.UpdateInitialViolationsLoadedStatus(key, true);
            this.agentListInfoService.UpdateViolationHistoryLoadingStatus(key, true);
            if (this.trsService.events[key] == null)
              this.trsService.events[key] = [];
          }
          continue;
        }
        else {
          try {
            const areInitialViolationsLoaded: boolean = this.agentListInfoService.AreInitialViolationsLoaded(key);

            let violationCountData: { [key: string]: number } = {};
            let otherViolationsCount: number = 0;
            let violationList: Violation[] = [];
            let violationNotificationCount: { [key: string]: { [key: string]: number } } = {};

            //Get the existing values if they exist
            if (violationNotificationCount[key] != null) {
              for (const [subKey, subValue] of Object.entries(violationNotificationCount[key])) {
                if (subKey === "OtherViolations")
                  otherViolationsCount = subValue;
                else violationCountData[subKey] = subValue;
              }
            }

            value.forEach((info: ViolationDetails) => {
              try {
                if (info.ViolationName != null && info.ViolationName != "") {
                  //Check if the violation already exists for that agent
                  const existingViolationDetails: Violation | null = this.trsService.events[key].find((v: Violation) => v.ViolationId === info.ViolationId)

                  if (existingViolationDetails != null) {
                    log.warn(`Violation with event id ${info.EventId}, violation id ${info.ViolationId} already exists for agent ${key}`, info);
                    return;
                  }

                  let violation: Violation = {
                    ...info,
                    ViolationUTCDateTime: new Date(),
                    Show: false,
                    ShowInChat: false,
                    AgentLanId: key,
                  };

                  if ((info.ViolationName === "PROFANITYWORDSDETECTED" || info.ViolationName === "NEGATIVESENTIMENTDETECTED") && info.ProfanityDetails != null) {
                    violation.ProfanityDetails = [];
                    Object.values(info.ProfanityDetails).forEach((profanity: IProfanityDetails) => {
                      if (profanity != null)
                        if (profanity.MessageSource !== "CALL_SUMMARY")
                          violation.ProfanityDetails!.push(profanity);
                        else violation.CallSummary = profanity.OriginalSpeechResult;
                    });
                  }

                  if (this.appConfig.settings.ChatEvents.includes(info.ViolationName)) {
                    violation.Show = false;
                    violation.ShowInChat = true;
                  }
                  else {
                    violation.Show = true;
                    violation.ShowInChat = false;
                  }

                  violation.ViolationName = violation.ViolationName.replace(/peep/gi, "Check-In");

                  if (this.enabledViolations.includes(violation.ViolationName)) {
                    if (violationCountData[violation.ViolationName] != null) {
                      violationCountData[violation.ViolationName]++;
                    }
                    else {
                      violationCountData[violation.ViolationName] = 1;
                    }
                  }
                  else {
                    const otherNotification: IViolationNotificationType | null = this.appConfig.settings.ViolationNotificationTypes["OtherViolations"];
                    if (otherNotification != null && otherNotification.enabled === true)
                      otherViolationsCount++;
                  }

                  FormatViolationDateTime(violation);

                  violationList.push(violation);
                  this.agentListInfoService.UpdateEventNames(key, violation.ViolationName);
                }
              } catch (error) {
                log.error(`An error occurred while processing a violation with event id ${info.EventId} and violation id ${info.ViolationId} for agent ${key}`, error, info);
                this.logUploader.error("handleLoadExtViolations", `An error occurred while processing a violation with event id ${info.EventId} and violation id ${info.ViolationId} for agent ${key}`, error);
              }
            });

            violationCountData["OtherViolations"] = otherViolationsCount;
            violationNotificationCount[key] = violationCountData;

            this.sendEvent("UPDATE_EVENT_FILTER", {});

            const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(key);
            if (agentInfo != null) {
              if (this.trsService.events[key] == null)
                this.trsService.events[key] = [];

              if (this.trsService.events[key].length > 0)
                this.trsService.events[key] = violationList.concat(this.trsService.events[key]);
              else this.trsService.events[key] = violationList;

              this.sortEventsForAgent(key);

              if (areInitialViolationsLoaded === false)
                this.agentListInfoService.UpdateInitialViolationsLoadedStatus(key, true);

              if (this.agentListInfoService.IsViolationHistoryLoadingComplete(key) === false) {
                //If the number of violations received in this request is 0 or 
                //If the number of violations received is less than the violations we had requested for
                //Then that means there are no more violations left to load in history and we mark it as complete
                if (value.length === 0 || value.length < this.violationsPerPage)
                  this.agentListInfoService.UpdateViolationHistoryLoadingStatus(key, true);
              }
            }
          } catch (error) {
            log.error(`An error occurred while processing violations for agent ${key}`, error, value);
            this.logUploader.error("handleLoadExtViolations", `An error occurred while processing violations for agent ${key}`, error);
          }
        }

        if (key === this.selectedLanId) {
          //Store all the violations of the currently selected agent
          this.selectedAgentViolations = this.trsService.events[key];
        }
      }
    }
  }

  handleSuperAdminMode(data: any) {
    this.userMode == 'superadmin' ? this.userMode = 'supervisor' : this.userMode = 'superadmin';
    this.dashboardView = false;
    this.gamificationView = false;
  }

  handlePinAndArchiveUI = (): void => {
    this.dontSelect = true;
    this.hideWaitingPopUp = false;

    setTimeout(() => {
      this.hideWaitingPopUp = true;
    }, 5000);
  }

  dontSelectAgents(response: any) {
    this.dontSelect = true;
    this.updateCounts(false);
  }

  clickAddButton() {
    this.additionalButtons = !this.additionalButtons;
  }

  toggleChatWidget() {
    this.showChatWidget = !this.showChatWidget;
  }

  getAgentsList(response: any) {
    this.hideLoading = true;

    this.pageChanged(1);

    this.agentListInfoService.ClearAgentList();

    //Iterate each agent
    response.data.forEach((agentInfo: AgentInfoWithProfilePic, index: number) => {
      this.addNewAgentInternal(agentInfo);
    });

    if (this.appConfig.settings.defaults.TeamCheckInEnabledByDefault === true) {
      this.teamCheckInService.setIsTeamCheckInActive(true);
      this.teamCheckInService.stopTeamCheckInMonitor();
      this.teamCheckInService.startTeamCheckInMonitor();
    }
    else {
      this.teamCheckInService.setIsTeamCheckInActive(false);
      this.teamCheckInService.stopTeamCheckInMonitor();
    }

    this.eventFilterService.stopEventFilterMonitor();
    this.eventFilterService.startEventFilterMonitor();

    if (this.selectedLanId !== "") {
      //This means some agent was selected before, so we select the agent back again, since it could get reset
      this.selectAgent(this.selectedLanId);
    }

    this.updateCounts();
    this.sendEvent("LOADED_DATA", {});
    this.loadTooltip();
  }

  initializeTooltip() {
    this.loadTooltip();
  }

  loadTooltip() {
    try {
      let interval = setInterval(() => {
        $('[data-bs-toggle="tooltip"]').tooltip({ trigger: 'hover' });
        $('[data-bs-toggle="tooltip"]').on('click', function () {
          $(this).tooltip('hide');
        })
      }, 1000);

      setTimeout(function () {
        clearInterval(interval);
      }, 2000) // stop it after 10seconds
    } catch (err) { }
  }

  getSupervisorInit(response: { data: any }) {
    this.AgentTime = response.data.AgentTime;
    if (!this.showViolationHistoryWidget)
      this.trsService.events = {};

    if (response.data["AgentRole"]) {
      if (response.data.AgentRole.indexOf("SupervisorCanSeeMedia") > -1)
        this.supervisorCanViewMedia = true;
      if (response.data.AgentRole.indexOf("SupervisorCannotSeeMedia") > -1)
        this.supervisorCanViewMedia = false;
    }

    this.agentListInfoService.AddAgentTime(response.data.AgentTime);
    this.tempAgentInfo = {};

    if (response.data.AgentList != null)
      response.data.AgentList.forEach((agentInfo: Agent) => {
        this.tempAgentInfo[agentInfo.LanID] = agentInfo;
      });
  }

  trsClientLoggedIn(response: any) {
    const info: ActionData = response.data;

    if (info.SessionData != null)
      this.agentListInfoService.UpdateAgentInfo(info.SessionData);
    else {
      this.agentListInfoService.UpdateCurrentAuxCode(info.AgentLanId, info.AgentCurrentAuxCode);
      this.agentListInfoService.UpdateLoggedInStatus(info.AgentLanId, info.IsLoggedIn);
      this.agentListInfoService.UpdateScreenblockStatus(info.AgentLanId, info.IsScreenBlocked);
      this.agentListInfoService.UpdateNotificationIconVisibilityStatus(info.AgentLanId, true);
      this.agentListInfoService.UpdateStealthModeActivatedStatus(info.AgentLanId, info.IsStealthModeActivated);

      if (info.ProfilePicUrl != null)
        this.agentListInfoService.UpdateProfilePicture(info.AgentLanId, info.ProfilePicUrl);
    }

    this.agentListInfoService.UpdateScreenblockStatus(info.AgentLanId, false);
    this.handleAuxCodeChange(info.AgentLanId, "LoggedIn");

    this.logUploader.info("trsClientLoggedIn", `Login Status: ${info.AgentLanId}: ${this.agentListInfoService.GetLoginStatusMessage(info.AgentLanId)}`);

    this.agentListInfoService.UpdateConnectionTime(info.AgentLanId, new Date());

    if (info.AgentTime)
      this.agentListInfoService.UpdateAgentTime(info.AgentLanId, info.AgentTime);

    if (this.selectedLanId == info.AgentLanId)
      this.updateIconsInChatUI(info.AgentLanId);

    this.agentListInfoService.MoveAgentToTopOfOrderList(info.AgentLanId);

    this.MoveAgentLanIdToTop(info.AgentLanId);
  }

  trsClientDisconnected(response: any) {
    const info: ActionData = response.data;

    this.agentListInfoService.UpdateAgentInfo(info.SessionData);

    if (this.pendingStealthRequested[info.AgentLanId] != null)
      delete this.pendingStealthRequested[info.AgentLanId];

    this.handleAuxCodeChange(info.AgentLanId, "Logged Out");

    this.logUploader.info("trsClientDisconnected", `Login Status: ${info.AgentLanId}: ${this.agentListInfoService.GetLoginStatusMessage(info.AgentLanId)}`);

    this.agentListInfoService.UpdateStealthModeActivatedStatus(info.AgentLanId, false);
    this.agentListInfoService.UpdateStealthModeRequestedStatus(info.AgentLanId, false);
    this.agentListInfoService.UpdateScreenblockStatus(info.AgentLanId, false);
    this.agentListInfoService.UpdateNotificationIconVisibilityStatus(info.AgentLanId, false);
    this.agentListInfoService.UpdateIsConnectedStatus(info.AgentLanId, info.SessionData.IsConnected);

    if (this.selectedLanId == info.AgentLanId)
      this.updateIconsInChatUI(info.AgentLanId);

    this.agentListInfoService.MoveAgentToTopOfOrderList(info.AgentLanId);

    this.MoveAgentLanIdToTop(info.AgentLanId);
  }

  trsClientConnected(response: any) {
    const info: ActionData = response.data;

    this.logUploader.info("trsClientConnected", `Login Status: ${info.AgentLanId}: ${this.agentListInfoService.GetLoginStatusMessage(info.AgentLanId)}`);

    if (this.agentListInfoService.DoesKeyExist(info.AgentLanId) === true) {
      this.agentListInfoService.UpdateAgentInfo(info.SessionData);

      if (info.AgentLanId == this.selectedLanId)
        this.updateIconsInChatUI(info.AgentLanId);

      this.handleAuxCodeChange(info.AgentLanId, info.SessionData.IsLoggedIn === true ? "LoggedIn" : "Available");
    }
    else {
      this.addNewAgentInternal({
        ...info.SessionData,
        AgentProfilePic: info.ProfilePicUrl,
      });

      this.sendEvent("UPDATE_TEAM_FOR_AGENT", {
        ...info.SessionData,
        AgentProfilePic: info.ProfilePicUrl,
      })

      this.updateCounts(false);

      if (info.AgentLanId == this.selectedLanId)
        this.updateIconsInChatUI(info.AgentLanId);
    }

    this.MoveAgentLanIdToTop(info.AgentLanId);
  }

  enableChatNotificationIcon = (response: any): void => this.agentListInfoService.UpdateChatEnabled(response.data.AgentLanId, true)

  handlePeep(response: any) {
    this.logUploader.info("handlePeep - Peep Requested", response.data.AgentLanId);

    this.enableChatNotificationIcon(response);
    response.data.ViolationName = "PEEP";
    response.data.ShowInChat = true;
    response.data.Show = false;
    response.data.ViolationDateTime = new Date();
    response["Time"] = new Date();
    response["Show"] = false;
    response["ViolationName"] = "Check-In";
    response["ShowInChat"] = true;

    this.addChatEventToViolationList(response.data.From, response.data.EventId, response.data.ViolationName, response.data.ViolationDetails);

    this.MoveAgentLanIdToTop(response.data.AgentLanId);
  }

  handleScreenGrab(agentLanId: string) {
    this.logUploader.info("ScreenGrab Requested", this.selectedLanId);
    let data: any = {};
    data.ViolationName = "SCREENGRAB";
    data.AgentLanId = this.selectedLanId;
    data.Show = false;
    data.ShowInChat = true;

    if (this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal === true)
      data.ViolationDateTime = new Date().toISOString();
    else data.ViolationDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal);

    this.agentListInfoService.UpdateScreenGrabRequestStatus(agentLanId, true);

    this.sendEvent("CUSTOM_SCREENGRAB_EVENT", data);
    data.ViolationName = "Screen Grab Request";

    this.addChatEventToViolationList(this.selectedLanId, "", data.ViolationName, data);
  }

  handlePeepDenied(response: any) {
    this.logUploader.info("Peep Denied", response.data.AgentLanId);
    this.enableChatNotificationIcon(response);
    response.data.ActionName = "PEEPDENIED";
    response.data.Show = false;
    response.data.ViolationName = "Check-In Denied";
    response.data.ShowInChat = true;

    if (this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal === true)
      response.data.ViolationDateTime = new Date().toISOString();
    else response.data.ViolationDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal);

    this.agentListInfoService.UpdateCheckInRequestStatus(response.data.AgentLanId, false);

    this.addChatEventToViolationList(response.data.AgentLanId, response.data.EventId, response.data.ViolationName, response.data);
    this.playNotification(response.data.AgentLanId, response.data.ViolationName);
    this.MoveAgentLanIdToTop(response.data.AgentLanId);
  }

  handlePeepComplete(response: any) {
    this.logUploader.info("PEEPCOMPLETE", response.data.AgentLanId);

    this.enableChatNotificationIcon(response);

    response.data.ActionName = "PEEPCOMPLETE";
    response.data.Show = false;
    response.data.ViolationName = "Check-In";
    response.data.EventId = "";

    if (this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal === true)
      response.data.ViolationDateTime = new Date().toISOString();
    else response.data.ViolationDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal);

    this.agentListInfoService.UpdateCheckInRequestStatus(response.data.AgentLanId, false);

    this.addChatEventToViolationList(response.data.AgentLanId, response.data.EventId, response.data.ViolationName, response.data);
    this.playNotification(response.data.AgentLanId, response.data.ViolationName);
    this.MoveAgentLanIdToTop(response.data.AgentLanId);
  }

  handleChatMessage(response: any) {
    response.data.ViolationName = response.data.ChatMessage;

    response.data.ViolationDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.SendInUTC);
    response.data.Show = false;
    response.data.ShowInChat = true;

    this.addChatEventToViolationList(response.data.AgentLanId, response.data.EventId, response.data.ViolationName, response.data);

    this.MoveAgentLanIdToTop(response.data.AgentLanId);
  }

  handleChatMessageReceived(response: any) {
    this.enableChatNotificationIcon(response);
    response.data.ViolationName = "CHATMESSAGERECEIVED";
    response.data.Show = false;
    response.data.ShowInChat = true;
    response.data.ActionName = "CHATMESSAGERECEIVED";
    response.data.Show = false;
    response.data.ShowInChat = true;

    if (this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal === true)
      response.data.ViolationDateTime = new Date().toISOString();
    else response.data.ViolationDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal);

    this.addChatEventToViolationList(response.data.AgentLanId, response.data.EventId, response.data.ViolationName, response.data);
    this.playNotification(response.data.AgentLanId, response.data.ViolationName);
    this.MoveAgentLanIdToTop(response.data.AgentLanId);
    this.auditService.AuditSupervisorUsage(15, response.data.AgentLanId, undefined, response.data.ChatMessage);
  }

  addChatToEvents = (data: { AgentLanId: string, ChatMessage: string }): void => {
    let data1: any = {};
    data1.ViolationName = "CHATMESSAGE";
    data1.Show = false;
    data1.ShowInChat = true;
    data1.ActionName = "CHATMESSAGE";
    data1.ChatMessage = data.ChatMessage;
    data1.Show = false;
    data1.ShowInChat = true;
    data1.EventId = null;

    if (this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal === true)
      data1.ViolationDateTime = new Date().toISOString();
    else data1.ViolationDateTime = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal);

    this.addChatEventToViolationList(data.AgentLanId, null, data1.ViolationName, data1);
    this.MoveAgentLanIdToTop(data.AgentLanId);
  }

  handleStealthMode(response: any) {
    this.playNotification(response.data.AgentLanId, "STEALTHMODE");

    this.agentListInfoService.UpdateStealthModeRequestedStatus(response.data.AgentLanId, true);
    let msg = response.data.ChatMessage;
    if (msg.indexOf("Activated") > -1) {
      this.agentListInfoService.UpdateStealthModeActivatedStatus(response.data.AgentLanId, true);
      this.agentListInfoService.UpdateStealthModeRequestedStatus(response.data.AgentLanId, false);
      delete this.pendingStealthRequested[response.data.AgentLanId];

      log.info(`Login Status for agent ${response.data.AgentLanId}: ${this.agentListInfoService.GetLoginStatusMessage(response.data.AgentLanId)}`);
    }
    else if (msg.indexOf("Deactivated") > -1) {
      this.agentListInfoService.UpdateStealthModeActivatedStatus(response.data.AgentLanId, false);
      this.agentListInfoService.UpdateStealthModeRequestedStatus(response.data.AgentLanId, false);
      delete this.pendingStealthRequested[response.data.AgentLanId];
    }
    else {
      this.toastrService.success(`${this.stealthModeRequestedLabel} ${response.data.AgentLanId}`);
      this.pendingStealthRequested[response.data.AgentLanId] = this.agentListInfoService.GetAgentFirstName(response.data.AgentLanId);

      if (this.appConfig.settings.ShowSystemNotificationsForViolationsAndEvents.includes("STEALTHMODE") === true)
        showNotification("Stealth Mode Request", `User ${response.data.AgentLanId} has requested for stealth mode`);
    }
    response.data.ViolationName = "STEALTHMODE";
    response.data.ShowInChat = true;

    response.data.ViolationDateTime = new Date();
    this.enableChatNotificationIcon(response);

    this.addChatEventToViolationList(response.data.AgentLanId, response.data.EventId, response.data.ViolationName, response.data);
    this.MoveAgentLanIdToTop(response.data.AgentLanId);
    this.updateIconsInChatUI(response.data.AgentLanId);
  }

  handleActivateStealthMode(response: any) {
    this.agentListInfoService.UpdateStealthModeRequestedStatus(response.data.AgentLanId, false);

    this.addChatEventToViolationList(response.data.AgentLanId, response.data.EventId, response.data.ViolationName, response.data);

    if (this.pendingStealthRequested[response.data.AgentLanId] != null)
      delete this.pendingStealthRequested[response.data.AgentLanId];

    this.enableChatNotificationIcon(response);
  }

  deactivateStealthMode() {
    if (this.pendingStealthRequested[this.selectedLanId] != null)
      delete this.pendingStealthRequested[this.selectedLanId];

    this.agentListInfoService.UpdateStealthModeActivatedStatus(this.selectedLanId, false);
    this.agentListInfoService.UpdateStealthModeRequestedStatus(this.selectedLanId, false);

    log.info(`Stealth Mode DeActivate Request for ${this.selectedLanId}`);

    this.sendEvent("CUSTOM_STEALTHMODE_ACTION", {
      AgentLanId: this.selectedLanId,
      ViolationDateTime: new Date(),
      AllowStatus: false,
      ViolationName: "StealthMode Deactivated",
      Show: false,
      ShowInChat: false,
    });
  }

  sendEvent = (eventName: any, responseData: any): void => this.trsService.evtdata.next({
    "eventName": eventName,
    "data": responseData
  });

  handleViolation = (lanId: string, violationDetails: ViolationDetails, playNotification: boolean, showNotificationIcon: boolean): void => {
    if (violationDetails.ViolationId == null || violationDetails.ViolationId === "") {
      log.warn(`Received violation event with empty violation id, not processing further`, violationDetails);
      return;
    }

    const agentViolationName: string = violationDetails.ViolationName;
    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanId);

    if (agentInfo == null) {
      log.error(`Info for agent ${lanId} is not present in local memory, cannot add violation`, violationDetails);
      this.logUploader.error(`handleViolation`, `Info for agent ${lanId} is not present in local memory, cannot add violation with eventid ${violationDetails.EventId} and violation id ${violationDetails.ViolationId}`, null)
      return;
    }
    //if archived do nothing
    else if (this.agentListInfoService.IsArchived(lanId) === true) {
      return;
    }

    log.info(`Processing new violation with event id ${violationDetails.EventId}, name ${agentViolationName} and violation id ${violationDetails.ViolationId}`);
    this.logUploader.info(`handleViolation`, `Processing new violation with event id ${violationDetails.EventId}, name ${agentViolationName} and violation id ${violationDetails.ViolationId}`);

    if (this.trsService.events[lanId] != null && this.trsService.events[lanId].length > 0 && (violationDetails.Category == null || (violationDetails.Category != null && violationDetails.Category !== "SA"))) {
      const doesViolationIdExist: boolean = this.trsService.events[lanId].some((existingValue: Violation) => existingValue.ViolationId === violationDetails.ViolationId);
      if (doesViolationIdExist === true) {
        log.error(`For agent ${lanId}, the new violation has an violation id of ${violationDetails.ViolationId} which is already present in the existing list`, null, violationDetails);
        this.logUploader.error(`handleViolation`, `For agent ${lanId}, the new violation has an violation id of ${violationDetails.ViolationId} which is already present in the existing list`, null);
        return;
      }
    }

    if (playNotification === true && this.appConfig.settings.ExcludedViolationsForNotificationSounds.includes(agentViolationName) === false)
      playNotificationSound();

    if (showNotificationIcon === true && this.appConfig.settings.ShowSystemNotificationsForViolationsAndEvents.includes(agentViolationName) === true)
      showNotification("Violation Occurred", `Violation ${agentViolationName} occurred for user ${lanId}`);

    let modifiedViolationDetails: Violation = {
      ...violationDetails,
      AgentLanId: lanId,
      Show: true,
      ShowInChat: false,
      ViolationUTCDateTime: new Date(),
    };
    let violationCountData: { [key: string]: number } = {};

    FormatViolationDateTime(modifiedViolationDetails);

    // Violations is dictionary of violation notification count
    if (agentInfo.Violations)
      violationCountData = agentInfo.Violations;

    if (this.enabledViolations.includes(agentViolationName)) {
      if (violationCountData[agentViolationName] != null)
        violationCountData[agentViolationName]++;
      else violationCountData[agentViolationName] = 1;
    }
    else {
      const otherNotification: IViolationNotificationType | null = this.appConfig.settings.ViolationNotificationTypes["OtherViolations"];
      if (otherNotification != null && otherNotification.enabled === true) {
        if (violationCountData["OtherViolations"] == null)
          violationCountData["OtherViolations"] = 0;

        violationCountData["OtherViolations"]++;
      }
    }

    // violationCountData is dictionary of violation notification count
    this.agentListInfoService.UpdateViolations(lanId, violationCountData);
    this.agentListInfoService.UpdateViolationKeys(lanId, Object.keys(violationCountData))

    if (this.trsService.events[lanId] == null)
      this.trsService.events[lanId] = [];

    this.agentListInfoService.UpdateEventNames(lanId, agentViolationName);

    this.sendEvent("UPDATE_EVENT_FILTER", {});

    log.debug(`Adding Violation to this.trsService.events: ${lanId}, ${modifiedViolationDetails.EventId}`);
    this.trsService.events[lanId].push(modifiedViolationDetails);
    this.sortEventsForAgent(lanId);

    if (this.selectedLanId == lanId) {
      this.agentListInfoService.UpdateNotificationIconVisibilityStatus(lanId, false);
      this.sendEvent("CUSTOM_VIOLATION_EVENT", modifiedViolationDetails);
    }
    else this.agentListInfoService.UpdateNotificationIconVisibilityStatus(lanId, true);

    //If the supervisor has not opened any agent tile yet but realtime violations are coming in
    //If the realtime violations received are more than the violations per page count, we mark initial violations as loaded
    if (this.agentListInfoService.AreInitialViolationsLoaded(lanId) === false)
      if (this.trsService.events[lanId].length >= this.violationsPerPage)
        this.agentListInfoService.UpdateInitialViolationsLoadedStatus(lanId, true);

    this.MoveAgentLanIdToTop(lanId);
  }

  handleSecureAssistEvent = (eventDetails: ISecureAssistEvent): void => {
    if (this.trsService.events[eventDetails.AgentLanId] != null && this.trsService.events[eventDetails.AgentLanId].length > 0) {
      const index: number = this.trsService.events[eventDetails.AgentLanId].findIndex((existingValue: Violation) => existingValue.ViolationId === eventDetails.SessionId);
      if (index > -1) {
        if (eventDetails.MessageSource === "CALL_SUMMARY")
          (<ViolationDetails>this.trsService.events[eventDetails.AgentLanId][index]).CallSummary = eventDetails.OriginalSpeechResult;

        else {
          (<ViolationDetails>this.trsService.events[eventDetails.AgentLanId][index]).Category = eventDetails.Category;
          (<ViolationDetails>this.trsService.events[eventDetails.AgentLanId][index]).CreatedDateTime = eventDetails.CreatedDateTime;
          // (<ViolationDetails>this.trsService.events[eventDetails.AgentLanId][index]).MessageSource = eventDetails.MessageSource;
          (<ViolationDetails>this.trsService.events[eventDetails.AgentLanId][index]).ModelVersion = eventDetails.ModelVersion;
          // (<ViolationDetails>this.trsService.events[eventDetails.AgentLanId][index]).ViolationDateTime = eventDetails.CreatedDateTime;

          const subIndex: number = this.trsService.events[eventDetails.AgentLanId][index].ProfanityDetails.findIndex((existingValue: IProfanityDetails) => existingValue.SubSessionId === eventDetails.SubSessionId);

          if (subIndex > -1) {
            (<IProfanityDetails>this.trsService.events[eventDetails.AgentLanId][index].ProfanityDetails[subIndex]).OriginalSpeechResult = eventDetails.OriginalSpeechResult;
            (<IProfanityDetails>this.trsService.events[eventDetails.AgentLanId][index].ProfanityDetails[subIndex]).ProfanityWords = eventDetails.ProfanityWords;
          }
          else (<IProfanityDetails[]>this.trsService.events[eventDetails.AgentLanId][index].ProfanityDetails).push({
            SubSessionId: eventDetails.SubSessionId,
            MessageSource: eventDetails.MessageSource,
            OriginalSpeechResult: eventDetails.OriginalSpeechResult,
            ProfanityWords: eventDetails.ProfanityWords,
            LastAudioUrlCustomer: null,
            LastAudioUrl: null,
            CreatedDateTime: eventDetails.CreatedDateTime ?? null,
          });
        }

        const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(eventDetails.AgentLanId);

        if (agentInfo == null)
          return;

        let violationCountData: { [key: string]: number } = {};

        // Violations is dictionary of violation notification count
        if (agentInfo.Violations)
          violationCountData = agentInfo.Violations;

        if (this.enabledViolations.includes(eventDetails.ActionName)) {
          if (violationCountData[eventDetails.ActionName] != null)
            violationCountData[eventDetails.ActionName]++;
          else violationCountData[eventDetails.ActionName] = 1;
        }
        else {
          const otherNotification: IViolationNotificationType | null = this.appConfig.settings.ViolationNotificationTypes["OtherViolations"];
          if (otherNotification != null && otherNotification.enabled === true) {
            if (violationCountData["OtherViolations"] == null)
              violationCountData["OtherViolations"] = 0;

            violationCountData["OtherViolations"]++;
          }
        }

        this.agentListInfoService.UpdateViolations(eventDetails.AgentLanId, violationCountData);
        this.agentListInfoService.UpdateViolationKeys(eventDetails.AgentLanId, Object.keys(violationCountData))

        if (this.selectedLanId == eventDetails.AgentLanId)
          this.agentListInfoService.UpdateNotificationIconVisibilityStatus(eventDetails.AgentLanId, false);
        else this.agentListInfoService.UpdateNotificationIconVisibilityStatus(eventDetails.AgentLanId, true);

        this.playNotification(eventDetails.AgentLanId, eventDetails.ActionName);

        return;
      }
    }

    const violation: ViolationDetails = {
      ActionSummary: "",
      AgentId: null,
      ApproverComments: null,
      BlackOutToken: null,
      BoundingBoxes: null,
      BuildVersion: null,
      CamPicURL: null,
      CamVideoURL: null,
      Category: eventDetails.Category,
      CreatedDateTime: eventDetails.CreatedDateTime,
      EventCategory: 0,
      EventId: 0,
      Ip: "",
      IsRejected: 0,
      Latitude: 0,
      Longitude: 0,
      ModelVersion: eventDetails.ModelVersion,
      RejectedBy: null,
      RejectedDateTime: "0001-01-01T00:00:00",
      RejectionComment: null,
      RejectionLabel: null,
      RepliedBy: null,
      RepliedDateTime: null,
      ReviewStatus: 3,
      ScreenShotURL: null,
      ScreenVideoURL: null,
      SenderComments: null,
      SentBy: null,
      SentDateTime: null,
      SignedCamPicURL: null,
      SignedCamVideoURL: null,
      SignedScreenShotURL: null,
      SignedScreenVideoURL: null,
      StatusCode: -1,
      Threshold: 0,
      ViolationCaptureDetails: null,
      ViolationCount: 0,
      ViolationDateTime: eventDetails.CreatedDateTime,
      ViolationId: eventDetails.SessionId,
      ViolationName: eventDetails.ActionName,
      WorkflowStatus: null,
      ProfanityDetails: [],
      CallSummary: null,
      ScreenGlanceDetails: null,
    };

    if (eventDetails.MessageSource === "CALL_SUMMARY")
      violation.CallSummary = eventDetails.OriginalSpeechResult;
    else violation.ProfanityDetails.push({
      SubSessionId: eventDetails.SubSessionId,
      MessageSource: eventDetails.MessageSource,
      OriginalSpeechResult: eventDetails.OriginalSpeechResult,
      ProfanityWords: eventDetails.ProfanityWords,
      LastAudioUrlCustomer: null,
      LastAudioUrl: null,
      CreatedDateTime: eventDetails.CreatedDateTime ?? null,
    });

    this.handleViolation(eventDetails.AgentLanId, violation, true, true);
  }

  handleSecureAssistProfanityAudioEvent = (eventDetails: ISecureAssistProfanityAudioEvent): void => {
    if (this.trsService.events[eventDetails.AgentLanId] != null && this.trsService.events[eventDetails.AgentLanId].length > 0) {
      const index: number = this.trsService.events[eventDetails.AgentLanId].findIndex((existingValue: Violation) => existingValue.ViolationId === eventDetails.SessionId);
      if (index > -1) {
        const subIndex: number = this.trsService.events[eventDetails.AgentLanId][index].ProfanityDetails.findIndex((existingValue: IProfanityDetails) => existingValue.SubSessionId === eventDetails.SubSessionId);

        if (subIndex > -1) {
          (<IProfanityDetails>this.trsService.events[eventDetails.AgentLanId][index].ProfanityDetails[subIndex]).LastAudioUrl = eventDetails.LastAudioUrl;
          (<IProfanityDetails>this.trsService.events[eventDetails.AgentLanId][index].ProfanityDetails[subIndex]).LastAudioUrlCustomer = eventDetails.LastAudioUrlCustomer;
        }
        else (<IProfanityDetails[]>this.trsService.events[eventDetails.AgentLanId][index].ProfanityDetails).push({
          SubSessionId: eventDetails.SubSessionId,
          MessageSource: null,
          OriginalSpeechResult: null,
          ProfanityWords: null,
          LastAudioUrlCustomer: eventDetails.LastAudioUrlCustomer,
          LastAudioUrl: eventDetails.LastAudioUrl,
          CreatedDateTime: eventDetails.CreatedDateTime ?? null,
        });

        return;
      }
    }

    this.handleViolation(eventDetails.AgentLanId, {
      ActionSummary: "",
      AgentId: null,
      ApproverComments: null,
      BlackOutToken: null,
      BoundingBoxes: null,
      BuildVersion: null,
      CamPicURL: null,
      CamVideoURL: null,
      Category: eventDetails.Category,
      CreatedDateTime: eventDetails.CreatedDateTime,
      EventCategory: 0,
      EventId: 0,
      Ip: "",
      IsRejected: 0,
      Latitude: 0,
      Longitude: 0,
      ModelVersion: eventDetails.ModelVersion ?? "",
      RejectedBy: null,
      RejectedDateTime: "0001-01-01T00:00:00",
      RejectionComment: null,
      RejectionLabel: null,
      RepliedBy: null,
      RepliedDateTime: null,
      ReviewStatus: 3,
      ScreenShotURL: null,
      ScreenVideoURL: null,
      SenderComments: null,
      SentBy: null,
      SentDateTime: null,
      SignedCamPicURL: null,
      SignedCamVideoURL: null,
      SignedScreenShotURL: null,
      SignedScreenVideoURL: null,
      StatusCode: -1,
      Threshold: 0,
      ViolationCaptureDetails: null,
      ViolationCount: 0,
      ViolationDateTime: eventDetails.CreatedDateTime,
      ViolationId: eventDetails.SessionId,
      ViolationName: "PROFANITYWORDSDETECTED",
      WorkflowStatus: null,
      ProfanityDetails: [{
        SubSessionId: eventDetails.SubSessionId,
        MessageSource: null,
        OriginalSpeechResult: null,
        ProfanityWords: null,
        LastAudioUrlCustomer: null,
        LastAudioUrl: null,
        CreatedDateTime: eventDetails.CreatedDateTime ?? null,
      }],
      CallSummary: null,
      ScreenGlanceDetails: null,
    }, false, false);
  }

  handleScreenBlockApproved = (response: any): void => {
    if (this.agentListInfoService.GetScreenblockStatus(response.data.AgentLanId) === false) {
      this.enableChatNotificationIcon(response);

      this.filterAgentsByScreenblock(false);

      if (this.appConfig.settings.ShowSystemNotificationsForViolationsAndEvents.includes("SCREENBLOCKAPPROVED") === true)
        showNotification("Screen Blocked", `User ${response.data.AgentLanId} screen has been blocked`);

      this.agentListInfoService.UpdateScreenblockStatus(response.data.AgentLanId, true);

      if (this.selectedLanId == response.data.AgentLanId)
        this.updateIconsInChatUI(response.data.AgentLanId);
    }
    else log.info(`${response.data.AgentLanId} screen is already blocked, not doing anything`);
  }

  handleUnBlockScreenApproved = (response: any): void => {
    if (this.agentListInfoService.GetScreenblockStatus(response.data.AgentLanId) === true) {
      this.enableChatNotificationIcon(response);

      if (this.appConfig.settings.ShowSystemNotificationsForViolationsAndEvents.includes("UNBLOCKSCREENAPPROVED") === true)
        showNotification("Screen Unblocked", `User ${response.data.AgentLanId} screen has been unblocked`);

      this.agentListInfoService.UpdateScreenblockStatus(response.data.AgentLanId, false);

      if (this.selectedLanId == response.data.AgentLanId)
        this.updateIconsInChatUI(response.data.AgentLanId);

      if (response.data.AgentTime) {
        this.agentListInfoService.UpdateAgentTime(response.data.AgentLanId, response.data.AgentTime);
        // if (this.selectedLanId == response.data.AgentLanId) {
        // this.sendEvent("AGENT_TIME", this.agents[index].AgentTime);
        // }
      }

      this.agentListInfoService.UpdateScreenblockStatus(response.data.AgentLanId, false);
      this.filterAgentsByScreenblock(false);
    }
    else log.info(`${response.data.AgentLanId} screen is already unblocked, not doing anything`);
  }

  addChatEventToViolationList = (lanid: string, eventId: string | null, agentViolationName: string, data: any): void => {
    // if event is for selected agent append it to events list
    if (this.trsService.events[lanid] == null)
      this.trsService.events[lanid] = [];

    // if (this.agentListInfoService.AreInitialViolationsLoaded(lanid) === true) {

    FormatViolationDateTime(data);

    log.debug(`Adding Chat to this.trsService.events: ${agentViolationName}, ${lanid}, ${eventId}`);

    this.trsService.events[lanid].push(data);
    this.sortEventsForAgent(lanid);
    if (this.selectedLanId == lanid)
      if (this.appConfig.settings.ChatEvents.includes(agentViolationName))
        this.sendEvent("ADDTOCHATUI", data);
    // }
    // else {
    //   if (data.ViolationName === "STEALTHMODE") {
    //     //This means initial n violations are not loaded for this user, but a stealth mode request has come
    //     //If stealth mode request comes via history, the problem is it will not be clickable so supervisor wont be able to accept/decline the stealth mode request
    //     //Add this request in the list
    //     log.debug(`Adding ChatEvents to this.trsService.events: ${agentViolationName}, ${lanid}, ${eventId}`);
    //     this.trsService.events[lanid].push(data);
    //   }
    //   else log.debug(`Not able to add chat event ${eventId} (${agentViolationName}), since initial violations are not loaded for agent ${lanid}`);
    // }
  }

  screenBlock() {
    //12.
    let data = {
      ACTION: "ACTIONS",
      "AgentLanId": this.selectedLanId,
      "ViolationDateTime": new Date(),
      "ViolationName": "CustomBlockScreen",
      "Show": false,
      "ShowInChat": true
    };

    this.sendEvent("CustomBlockScreen", data);

    this.trsService.UploadMilestoneAction({
      SummaryId: this.trsService.traceId,
      Action: "Screen Block Request for " + this.selectedLanId,
      OtherData: "NA",
      ActionDateTime: getUTCDateObj(),
    })
  }

  screenUnBlock() {
    let data = {
      ACTION: "ACTIONS",
      "AgentLanId": this.selectedLanId,
      "ViolationDateTime": new Date(),
      "ViolationName": "CustomUnBlockScreen",
      "Show": false,
      "ShowInChat": true
    };

    this.sendEvent("CustomUnBlockScreen", data);
  }

  peepRequest(agentLanId: string) {
    let time = getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.SendInUTC);
    let data = {
      "ViolationName": "PEEP Request",
      "AgentLanId": this.selectedLanId,
      "ViolationDateTime": time,
      "Show": false,
      "ShowInChat": true
    };
    this.sendEvent("CUSTOM_PEEP_EVENT", data);
    this.enableChatNotificationIcon({ "data": data });
    data.ShowInChat = true;
    data.ViolationName = "Check-In request sent";

    this.addChatEventToViolationList(this.selectedLanId, "", data.ViolationName, data);

    this.agentListInfoService.UpdateCheckInRequestStatus(agentLanId, true);

    this.trsService.UploadMilestoneAction({
      SummaryId: this.trsService.traceId,
      Action: `PEEP Request for ${this.selectedLanId}`,
      OtherData: "NA",
      ActionDateTime: getUTCDateObj(),
    })
  }

  goBackToAllAgents() {
    log.debug(`goBackToAllAgents ${this.userMode}`);
    this.dashboardView = this.gamificationView = false;
    if (this.userMode == 'superadmin') {
      this.userMode = 'supervisor';
      return;
    }
    this.sendEvent('NAVIGATE_TO_ALL_AGENTS', {});
    this.showViolationHistoryWidget = false;
    this.showChatWidget = false;
    this.additionalButtons = false;
    this.agentListInfoService.UpdateIsSelected(this.selectedLanId, false);
    this.selectedLanId = '';
  }

  conditionalStealthModeClicked() {
    this.hideConfimationPopUp = false;
  }

  refresh() {
    this.resetAllFilters('');
    if (Object.keys(this.pendingStealthRequested).length > 0) {
      this.conditionalStealthModeClicked();
      return;
    }
    this.hideLoading = false;
    this.selectedLanId = "";
    this.sendEvent("REFRESH", "");
    this.trsService.events = {};
    this.showViolationHistoryWidget = false;
    this.showChatWidget = false;
  }

  //selected agent lanid
  selectAgent = (lanId: string) => {
    log.debug(`Selected Agent: ${lanId}`);
    if (this.dontSelect) {
      this.dontSelect = false;
      return;
    }

    this.selectedLanId = lanId;
    this.trsService.selectedAgentId = lanId;
    this.selectedAgentViolations = this.trsService.events[lanId];

    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanId);
    if (agentInfo == null)
      return;

    this.agentListInfoService.UpdateNotificationIconVisibilityStatus(lanId, false);
    this.agentListInfoService.UpdateChatEnabled(lanId, false);
    this.agentListInfoService.UpdateStealthModeRequestedStatus(lanId, false);
    this.agentListInfoService.UpdateIsSelected(lanId, true);
    this.agentListInfoService.UpdateViolations(lanId, {});
    this.agentListInfoService.UpdateViolationKeys(lanId, Object.keys({}));

    this.trsService.selectedAgentAvayaId = agentInfo.AvayaLoginId;

    this.showViolationHistoryWidget = true;
    this.showChatWidget = true;
    this.selectedProfilePic = agentInfo.AgentProfilePic;
    this.AgentStatus = agentInfo.LoginStatus;
    this.connectionTime = agentInfo.ConnectionTime;
    this.selectedTime = this.trsService.AgentTime[lanId];

    if (this.appConfig.settings.defaults.EnableAgentTime === true)
      this.sendEvent("AGENT_TIME", this.selectedTime);

    if (agentInfo.IsViolationHistoryLoadingComplete === false) {
      // if initial violations are loaded dont load again
      // else load initial violations
      if (agentInfo.InitialViolationsLoaded === true)
        this.sendEvent("SELECTED_AGENT", lanId);
      else this.sendRequestForViolations(lanId, 0, this.violationsPerPage);
    }
    else this.sendEvent("SELECTED_AGENT", lanId);

    //This event is sent so that when any agent is selected from the list, other ui components are aware that an agent is selected
    //The SELECTED_AGENT event will not be fired always an agent is selected, so ui components cannot always rely on it
    this.sendEvent("AGENT_CHANGED", lanId);
    //This event is sent so that the chat icons in chat component can be updated when the agent is changed
    setTimeout(() => this.updateIconsInChatUI(lanId), 50);
    this.auditService.AuditSupervisorUsage(8, lanId);
  }

  updateIconsInChatUI = (lanId: string): void => this.sendEvent("UPDATE_CHAT_FOR_AGENT", lanId);

  onNetworkReconnected = (): void => {
    //This means network got reconnected, fetch the last 20 records for all agents
    const lanIdList: string[] = this.agentListInfoService.GetAllLanId();

    lanIdList.forEach((lanId: string) => {
      if (this.agentListInfoService.AreInitialViolationsLoaded(lanId) === true)
        this.sendRequestForViolations(lanId, 0, this.violationsPerPage);
    });
  }

  sendRequestForViolations = (lanId: string, recordCount: number, pageSize: number): void => {
    let data = {
      agentLanId: lanId,
      recordCount: recordCount,
      pageSize: pageSize,
    };
    this.sendEvent("loadNextViolationsData", data);
  }

  SSOLogOut = (): void => {
    const idpId: number | null = this.appConfig.settings.SSO.IDPId;

    if (idpId !== 2) {
      try {
        const that = this;
        $.ajax({
          url: `${this.appConfig.settings.SSO.jwtAuthServerUrl}/LogOut?returnUrl=${window.location.origin}${window.location.pathname}`,
          type: "POST",
          xhrFields: {
            withCredentials: true,
          },
          success: (data: { cookieName: string; cookieValue: string; cookies: string[]; location: string; status: boolean; }, status, xhr: JQueryXHR) => {
            data.cookies.forEach((key: string, index: number) => {
              log.info(`Removing cookie: ${key}`);
              that.logUploader.info("SSOLogout", `Removing cookie: ${key}`);
              document.cookie = `${key}=; path=/; secure; samesite=none;expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${that.appConfig.settings.SSO.sSSODomain}`;
            });

            that.handleLogOut(true, data.location, false);
          },
          error: function (xhr: JQueryXHR, status, err) {
            log.error(`An error occurred while trying to logout via SSO`, null, `Status Code: ${xhr.status},\n${xhr.responseText == null ? status : xhr.responseText}`);
            that.logUploader.error("SSOLogout", `Status Code: ${xhr.status},\n${xhr.responseText == null ? status : xhr.responseText}`, null);
          },
        });
      } catch (ex) {
        log.error(`Exception in SSOLogOut`, ex);
        this.logUploader.error("SSOLogout", ``, ex);
      }
    }
    else {
      this.handleLogOut(false, null, true);
    }
  }

  IAMLogout = async () => {
    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("access-token-swfh_supervisor", this.trsService.iamToken);
    headers.append("Iam-Api-Session", this.trsService.iamUIAPISession);

    const url: string = `${this.appConfig.settings.IAM.API_URL}/api/v2/logout/swfh_supervisor`;

    try {
      const apiResponse: Response = await fetch(url, { method: 'GET', headers });
      log.info(`Status of trying to logout via IAM`, apiResponse);
      this.logUploader.info("IAMLogout", `Status of trying to logout via IAM: ${apiResponse.status}`);
      const jsonResponse = await apiResponse.json();
      if (jsonResponse.isSuccess != null && jsonResponse.isSuccess === true) {
        this.handleLogOut(true, jsonResponse.location, false);
      }
      else {
        log.error(`Unable to logout via IAM`, jsonResponse);
      }
    }
    catch (error) {
      log.error(`An error occurred while trying to logout via IAM`, null, error);
      this.logUploader.error("IAMLogout", `An error occurred while trying to logout via IAM`, error);
    }
  }

  toggleScreenblockFilter = (): void => {
    if (this.hideLoading) {
      this.resetAllFilters("screenblock");
      this.isScreenblockFilterEnabled = !this.isScreenblockFilterEnabled;
      this.filterAgentsByScreenblock(true);
    }
  }

  filterAgentsByScreenblock = (resetAgentsForNoFilter: boolean): void => {
    if (this.isScreenblockFilterEnabled === true) {
      this.pageChanged(1);
      this.updateCounts();
    }
    else {
      if (resetAgentsForNoFilter === true) {
        this.pageChanged(1);
        this.updateCounts();
      }
    }
  }

  resetAllFilters = (currentFilter: "screenblock" | "teams" | "status" | "search" | "event" | ""): void => {
    switch (currentFilter) {
      case "screenblock":
        this.teamsFilter = [];
        this.statusFilter = [];
        this.searchText = '';
        this.sendEvent("RESET_STATUS_FILTER", {});
        this.sendEvent("RESET_EVENT_FILTER", {});
        if (this.trsService.supervisorOrgHierarchy != null)
          this.sendEvent("RESET_TEAMS", {});
        break;
      case "teams":
        this.isScreenblockFilterEnabled = false;
        this.statusFilter = [];
        this.searchText = '';
        this.eventFilter.clear();
        this.sendEvent("RESET_STATUS_FILTER", {});
        this.sendEvent("RESET_EVENT_FILTER", {});
        break;
      case "status":
        this.isScreenblockFilterEnabled = false;
        this.teamsFilter = [];
        this.searchText = '';
        this.eventFilter.clear();
        this.sendEvent("RESET_EVENT_FILTER", {});
        if (this.trsService.supervisorOrgHierarchy != null)
          this.sendEvent("RESET_TEAMS", {});
        break;
      case "search":
        this.teamsFilter = [];
        this.statusFilter = [];
        this.eventFilter.clear();
        this.isScreenblockFilterEnabled = false;
        this.sendEvent("RESET_STATUS_FILTER", {});
        this.sendEvent("RESET_EVENT_FILTER", {});
        if (this.trsService.supervisorOrgHierarchy != null)
          this.sendEvent("RESET_TEAMS", {});
        break;
      case "event":
        this.teamsFilter = [];
        this.statusFilter = [];
        this.isScreenblockFilterEnabled = false;
        this.searchText = '';
        this.sendEvent("RESET_STATUS_FILTER", {});
        if (this.trsService.supervisorOrgHierarchy != null)
          this.sendEvent("RESET_TEAMS", {});
        break;
      case "":
        this.teamsFilter = [];
        this.statusFilter = [];
        this.eventFilter.clear();
        this.isScreenblockFilterEnabled = false;
        this.searchText = '';
        this.sendEvent("RESET_STATUS_FILTER", {});
        this.sendEvent("RESET_EVENT_FILTER", {});
        if (this.trsService.supervisorOrgHierarchy != null)
          this.sendEvent("RESET_TEAMS", {});
        break;
    }
  }

  isFilterEnabled = (): boolean => {
    if (this.isScreenblockFilterEnabled === true ||
      (this.teamsFilter != null && this.teamsFilter.length > 0) ||
      (this.statusFilter != null && this.statusFilter.length > 0) ||
      (this.searchText != null && this.searchText.length > 0) ||
      (this.eventFilter != null && this.eventFilter.size > 0))
      return true;
    else return false;
  }

  handlePinAgentResponse = (response: any): void => {
    if (response.data != null && response.data.length > 0) {
      response.data.forEach((agentInfo: AgentInfoWithProfilePic) => {
        const existingPinnedStatus: boolean = this.agentListInfoService.GetPinnedStatus(agentInfo.LanID);

        this.agentListInfoService.UpdatePinnedStatus(agentInfo.LanID, agentInfo.IsPinned);

        log.debug(`For agent ${agentInfo.LanID} existing pinned status is ${existingPinnedStatus} and updated pinned status is ${agentInfo.IsPinned}`);

        if (existingPinnedStatus !== agentInfo.IsPinned) {
          this.agentListInfoService.MoveAgentToTopOfOrderList(agentInfo.LanID);
        }
      });

      this.pageChanged(1);
    }

    this.hideWaitingPopUp = true;
  }

  handleArchivedAgentResponse = (response: any): void => {
    if (response.data != null && response.data.length > 0) {
      response.data.forEach((agentInfo: AgentInfoWithProfilePic) => {
        const existingArchivedStatus: boolean = this.agentListInfoService.GetArchivedStatus(agentInfo.LanID);

        this.agentListInfoService.UpdateArchivedStatus(agentInfo.LanID, agentInfo.IsArchived);

        log.debug(`For agent ${agentInfo.LanID} existing archived status is ${existingArchivedStatus} and updated archived status is ${agentInfo.IsArchived}`);

        if (existingArchivedStatus !== agentInfo.IsArchived)
          this.agentListInfoService.MoveAgentToTopOfOrderList(agentInfo.LanID);
      });

      this.updateCounts(true);
    }

    this.hideWaitingPopUp = true;
  }

  addNewAgentInternal = (agentInfo: AgentInfoWithProfilePic): void => {
    const agent: Agent = {
      ...agentInfo,
      IsViolationHistoryLoadingComplete: false,
      InitialViolationsLoaded: false,
      isSelected: false,
      AgentTime: this.AgentTime[agentInfo.LanID],
      FullName: `${agentInfo.AgentFirstName} ${agentInfo.AgentLastName}`,
      LoginStatus: '',
      Violations: {},
      ViolationKeys: [],
      ChatEnabled: false,
      IsStealthModeRequested: false,
      UploadLogStatus: false,
      IsCheckInRequestSent: false,
      IsScreenGrabRequestSent: false,
      ShowNotificationIcons: false,
      ProfilePicLoadRetryCount: 0,
      EventNames: new Set<string>(),
    };

    //Agent features and individual features are sent in supervisor init which we store in a temp variable, assign it back
    if (this.tempAgentInfo[agentInfo.LanID] != null) {
      agent.AgentFeatures = this.tempAgentInfo[agentInfo.LanID].AgentFeatures;
      agent.AgentIndividualFeatures = this.tempAgentInfo[agentInfo.LanID].AgentIndividualFeatures;
    }
    else {
      agent.AgentFeatures = agentInfo.AgentFeatures ?? [];
      agent.AgentIndividualFeatures = agentInfo.AgentIndividualFeatures ?? [];
    }

    if (this.agentListInfoService.DoesKeyExist(agentInfo.LanID) === false)
      this.agentListInfoService.AddSingleAgentInfoToList(agent);

    if (this.agentListInfoService.DoesAgentExistInOrderList(agentInfo.LanID) === false)
      this.agentListInfoService.AddAgentToOrderList(agentInfo.LanID);

    //Set the status message
    if (agentInfo.IsConnected === true) {
      if (agentInfo.IsLoggedIn === true) {
        if (agentInfo.AgentCurrentAuxCode != null && agentInfo.AgentCurrentAuxCode !== "")
          switch (agentInfo.AgentCurrentAuxCode.toLowerCase()) {
            case "break":
              this.handleAuxCodeChange(agentInfo.LanID, "Break");
              break;
            case "busy":
              this.handleAuxCodeChange(agentInfo.LanID, "Busy");
              break;
            case "meeting":
              this.handleAuxCodeChange(agentInfo.LanID, "Meeting");
              break;
            default:
              this.handleAuxCodeChange(agentInfo.LanID, "LoggedIn");
              break;
          }
        else this.handleAuxCodeChange(agentInfo.LanID, "LoggedIn");

        agent.ShowNotificationIcons = true;
      }
      else this.handleAuxCodeChange(agentInfo.LanID, "Available");
    }
    else {
      this.handleAuxCodeChange(agentInfo.LanID, "Logged Out");

      //Sometimes even though agent is logged out, IsScreenBlocked comes as true
      if (agentInfo.IsScreenBlocked === true)
        this.agentListInfoService.UpdateScreenblockStatus(agentInfo.LanID, false);
    }

    //Create an entry for events for this agent (if it exists already, reset it)
    this.trsService.events[agentInfo.LanID.toUpperCase()] = [];
  }

  updateComponentLabels = (): void => {
    this.loadingAgentDetailsLabel = this.translationService.translate("Loading Agent Details");
    this.goBackLabel = this.translationService.translate("Go Back");
    this.archivedAgentsLabel = this.translationService.translate("Archived Agents");
    this.activeAgentsLabel = this.translationService.translate("Agents");
    this.agentCountLabel = this.translationService.translate("Agent Count");
    this.refreshLabel = this.translationService.translate("Refresh");
    this.archivedLabel = this.translationService.translate("Archived");
    this.activeLabel = this.translationService.translate("Active");
    this.noAgentsArchivedLabel = this.translationService.translate("No Agents Archived");
    this.noRecordsMatchedLabel = this.translationService.translate("No records matched");
    this.itemsPerPageLabel = this.translationService.translate("Items per page");
    this.previousLabel = this.translationService.translate("Prev");
    this.nextLabel = this.translationService.translate("Next");
    this.pendingStealthRequestsLabel = this.translationService.translate("Pending Requests");
    this.concludeStealthRequestsLabel = this.translationService.translate("Please conclude the pending stealth mode requests and try again.");
    this.okLabel = this.translationService.translate("OK");
    this.pleaseWaitLabel = this.translationService.translate("Please Wait");
    this.updatingLabel = this.translationService.translate("Updating");
    this.searchLabel = this.translationService.translate("Search");
    this.logUploadedSuccessfullyLabel = this.translationService.translate("Logs uploaded successfully for agent");
    this.stealthModeRequestedLabel = this.translationService.translate("Stealth Mode Requested by");
    this.teamCheckInLabel = this.translationService.translate("Team Check-In");
  }

  sortEventsForAgent = (lanId: string): void => {
    this.trsService.events[lanId].sort((a: Violation, b: Violation): number => {
      try {
        return a.ViolationUTCDateTime.getTime() - b.ViolationUTCDateTime.getTime();
      }
      catch (e) {
        log.error(`An error occurred while comparing datetimes ${a.ViolationUTCDateTime} and ${b.ViolationUTCDateTime}`, e, a, b);
        return -1;
      }
    });
  }

  playNotification = (lanId: string, violationName: string): void => {
    if (this.agentListInfoService.IsArchived(lanId) === false && this.appConfig.settings.ExcludedViolationsForNotificationSounds.includes(violationName) === false)
      playNotificationSound();
  }

  hideGlobalEventFilterPopup = (): void => {
    this.isEventsGlobalFilterHidden = true;
  }

  toggleGlobalEventFilterPopup = (): void => {
    if (this.hideLoading) {
      this.isEventsGlobalFilterHidden = !this.isEventsGlobalFilterHidden;
    }
  }

  filterAgentsByEvents = (eventList: Set<string>): void => {
    this.resetAllFilters("event");
    this.eventFilter = eventList;
    this.pageChanged(1);
    this.updateCounts();
  }

  hideGlobalFilterPopup = (): void => {
    this.isGlobalFilterHidden = true;
  }

  toggleGlobalFilterPopup = (): void => {
    if (this.hideLoading)
      this.isGlobalFilterHidden = !this.isGlobalFilterHidden;
  }

  clearAllFilters = (): void => {
    this.resetAllFilters("");
    this.pageChanged(1);
    this.updateCounts();
  }

  addRealtimeScreenGlanceEventToHistory = (screenGlanceEventName: 'BARGEININIT' | 'BARGEIN' | 'BARGEINLIMITREACHED' | 'BARGEININITDECLINED' | 'ENDBARGEIN' | 'BARGEININPROGRESS', data: any): void => {
    if (screenGlanceEventName === 'BARGEIN')
      return;

    let violationName: string = "";
    let endReason: string = data.message ?? "";

    switch (screenGlanceEventName) {
      case "BARGEININIT":
        violationName = "Screen Glance Initiated";
        break;
      case "BARGEINLIMITREACHED":
        violationName = "Screen Glance Failed";
        endReason = `Screen Glance Failed Because License Limit Reached`;
        break;
      case "BARGEININITDECLINED":
        violationName = "Screen Glance Denied";
        break;
      case "ENDBARGEIN":
        violationName = "Screen Glance Ended";
        break;
      case "BARGEININPROGRESS":
        violationName = "Screen Glance Started";
        break;
    }

    const screenGlanceDetails: IScreenGlanceDetails = {
      EventId: data.EventId ?? 0,
      CreatedDateTime: data.CreatedDateTime,
      EndReason: endReason,
      SessionId: data.UniqueId,
      Id: 0,
      Initiator: data.From,
      Recipient: data.To,
    }

    if (data.FromId.toLowerCase().includes("supervisor") === false) {
      screenGlanceDetails.Initiator = data.To;
      screenGlanceDetails.Recipient = data.From;
    }

    const violation: ViolationDetails = {
      ActionSummary: "",
      AgentId: null,
      ApproverComments: null,
      BlackOutToken: null,
      BoundingBoxes: null,
      BuildVersion: null,
      CamPicURL: null,
      CamVideoURL: null,
      Category: null,
      CreatedDateTime: data.CreatedDateTime,
      EventCategory: 0,
      EventId: data.EventId ?? 0,
      Ip: "",
      IsRejected: 0,
      Latitude: 0,
      Longitude: 0,
      ModelVersion: "",
      RejectedBy: null,
      RejectedDateTime: "0001-01-01T00:00:00",
      RejectionComment: null,
      RejectionLabel: null,
      RepliedBy: null,
      RepliedDateTime: null,
      ReviewStatus: 3,
      ScreenShotURL: null,
      ScreenVideoURL: null,
      SenderComments: null,
      SentBy: null,
      SentDateTime: null,
      SignedCamPicURL: null,
      SignedCamVideoURL: null,
      SignedScreenShotURL: null,
      SignedScreenVideoURL: null,
      StatusCode: -1,
      Threshold: 0,
      ViolationCaptureDetails: null,
      ViolationCount: 0,
      ViolationDateTime: data.CreatedDateTime,
      ViolationId: data.ViolationId,
      ViolationName: violationName,
      WorkflowStatus: null,
      ProfanityDetails: [],
      CallSummary: null,
      ScreenGlanceDetails: screenGlanceDetails,
    };

    this.handleViolation((data.FromId.toLowerCase().includes("supervisor") === true ? data.To : data.From), violation, false, false);
  }
}